// extracted by mini-css-extract-plugin
export default {"box":"Circle_box__YspCZ","boxshadow":"Circle_boxshadow__x91fg"};